<template>
    <ul class="nav-list">
        <template v-if="loading">
            <!-- 第一个骨架项（"所有省份"） -->
            <li class="nav-item skeleton-item skeleton-header">
                <el-skeleton-item variant="text" style="width: 80%; height: 20px;"/>
            </li>
            <!-- 省份列表骨架项 -->
            <li v-for="i in 30" :key="i" class="nav-item skeleton-item">
                <el-skeleton-item variant="text" style="width: 90%; height: 20px;"/>
            </li>
        </template>
        <template v-else>
            <div class="nav-checks">
                <el-radio-group v-model="examType" @change="navTabChange">
                    <el-radio :label="0">公务员考试</el-radio>
                    <el-radio :label="1">事业单位考试</el-radio>
                </el-radio-group>
            </div>
            <div class="nav-all-area" :class="{'active': selectedId === null}" @click.stop="selectedCategory()">
                {{ examType === 0 ? '所有省份' : '所有地区' }}
            </div>
            <template v-for="(item, index) in areaList">
                <el-tooltip
                    effect="dark"
                    :content="item.content"
                    placement="right"
                    v-if="item.content.length > 4"
                    :key="item.areaId"
                >
                    <span
                        class="nav-item"
                        :class="{active: selectedId === item.areaId}"
                        @click="selectedCategory(item)"
                    >
                        {{ item.content }}
                    </span>
                </el-tooltip>
                <span
                    class="nav-item"
                    :class="{active: selectedId === item.areaId}"
                    @click="selectedCategory(item)"
                    v-else
                    :key="item.areaId"
                >
                    {{ item.content }}
                </span>
            </template>
        </template>
    </ul>
</template>

<script>
export default {
    data() {
        return {
            selectedId: localStorage.getItem('selectedAreaId') ? Number(localStorage.getItem('selectedAreaId')) : null,
            loading: false,
            examType: 0, // 0: 公务员考试, 1: 事业单位考试
        }
    },
    computed: {
        areaList() {
            return this.$store.getters["category/getState"].areaCategoryList;
        }
    },
    created() {
        this.loadAreaList();
    },
    methods: {
        async loadAreaList() {
            if (this.areaList.length === 0) {
                this.loading = true;
                try {
                    await this.$store.dispatch('category/GetAreaList');
                } catch (error) {
                    console.error('加载地区列表失败:', error);
                    this.$message.error('加载地区列表失败');
                } finally {
                    this.loading = false;
                }
            }
        },
        selectedCategory(item) {
            if (item) {
                this.selectedId = item.areaId;
                localStorage.setItem('selectedAreaId', item.areaId);
            } else {
                this.selectedId = null;
                localStorage.removeItem('selectedAreaId');
            }
            // 向父组件发送选中的 areaId
            this.$emit('areaChange', this.selectedId);
        },
        // 切换事业单位｜公务员 TAB
        navTabChange(value) {
            this.selectedId = null;
            localStorage.removeItem('selectedAreaId');
            this.$emit('areaChange', this.selectedId);
            this.$store.commit('user/SET_DATA_TYPE', value);
            this.$store.dispatch('category/GetAreaList');
        }
    },
    mounted() {
        this.examType = this.$store.state.user.dataType;
    }
}
</script>

<style lang='scss'>
.nav-list {
    width: 148px;
    min-height: auto;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    padding: 12px 8px;
    background-color: $background-color;
    border-radius: 10px;
    transition: all .2s;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start;

    /* 隐藏滚动条但保持滚动功能 */
    &::-webkit-scrollbar {
        width: 0;
        display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .nav-checks {
        width: calc(100% - 24px);
        margin: 10px 12px 0 12px;
        padding-bottom: 8px;
        border-bottom: 1px #e3e3e3 solid;

        .el-radio {
            margin-right: 8px;
            margin-bottom: 8px; /* 增加下边距，拉大上下距离 */
            display: block; /* 使单选按钮独占一行 */
            
            .el-radio__input {
                .el-radio__inner {
                    border-radius: 2px; /* 方形单选框 */
                    width: 16px;
                    height: 16px;
                    
                    &:hover {
                        border-color: $color-primary; /* 悬浮时边框使用主题色 */
                    }
                    
                    &::after {
                        width: 6px;
                        height: 6px;
                        border-radius: 0; /* 方形勾选标记 */
                        background-color: $color-primary; /* 使用主题色 */
                    }
                }
                
                &.is-checked {
                    .el-radio__inner {
                        border-color: $color-primary; /* 边框使用主题色 */
                        background-color: #fff; /* 保持背景为白色 */
                    }
                }
                
                &:hover:not(.is-checked) {
                    .el-radio__inner {
                        border-color: $color-primary; /* 悬浮未选中状态也使用主题色边框 */
                    }
                }
            }
            
            .el-radio__label {
                color: $font-color-primary;
                font-size: $font-size-primary !important;
                padding-left: 6px;
            }
            
            &.is-checked {
                .el-radio__label {
                    color: $color-primary; /* 选中文字使用主题色 */
                }
            }
        }
    }

    .nav-all-area {
        width: calc(100% - 24px);
        height: 24px;
        line-height: 24px;
        margin: 3px 12px 3px 12px;
        border-bottom: 1px #e3e3e3 solid;
        text-align: center;
        cursor: pointer;

        &.active {
            border-radius: 3px;
            background-color: rgb(229, 243, 243);
            color: $color-primary;
        }
    }

    .nav-item {
        position: relative;
        width: 64px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: $font-color-primary;
        border-radius: 3px;
        transition: background-color .2s, color .2s;
        cursor: pointer;
        margin-bottom: 4px;
        padding: 0 2px;
        white-space: nowrap; /* 禁止文本换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */

        &.active, &:hover {
            background-color: $background-color-fourth;
            color: $color-primary;
        }
    }

    .skeleton-item {
        background-color: transparent !important;
        cursor: default;

        &:hover {
            background-color: transparent !important;
            color: inherit;
        }

        :deep(.el-skeleton__text) {
            height: 100% !important;
        }

        &.skeleton-header {
            flex-basis: 100% !important;
            margin: 0 0 4px 0;

            &::after {
                content: '';
                position: absolute;
                bottom: -2px;
                left: 0;
                width: 100%;
                height: 1px;
                background: #ddd;
                transform: scaleY(.5);
            }
        }
    }
}
</style>